import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {HAS_RECOMMENDATION_POPOVER_BEEN_CLOSED} from "../../app/constants/storage_keys";
import {IRPStore} from "../../app/rp_reducer";
import {sessionCache} from "../../utils/session_cache";
import {useUserRecommendationState} from "./use_user_recommendation_state";

const POPOVER_ACTIVATION_DELAY = 5000;

export const useUserRecommendationPopover = () => {
    const [hasPopoverBeenClosed, setHasPopoverBeenClosed] = useState<boolean>(sessionCache.get<boolean>(HAS_RECOMMENDATION_POPOVER_BEEN_CLOSED) || false);
    const [isPopoverActive, setIsPopoverActive] = useState(false);
    const {recommendedCount} = useUserRecommendationState();
    const userPrefs = useSelector((state: IRPStore) => state.user.preferences?.data?.filters);
    const userPrefRegions = userPrefs?.region;
    const userPrefFilters =
        userPrefs?.price_0 ||
        userPrefs?.price_1 ||
        userPrefs?.area_0 ||
        userPrefs?.area_1 ||
        userPrefs?.rooms_0 ||
        userPrefs?.rooms_1 ||
        userPrefs?.construction_end_date ||
        userPrefs?.floor_choices;

    useEffect(() => {
        if (recommendedCount > 0 && !hasPopoverBeenClosed && !!userPrefRegions && !!userPrefFilters) {
            const timeoutId = setTimeout(() => {
                setIsPopoverActive(true);
            }, POPOVER_ACTIVATION_DELAY);

            return () => clearTimeout(timeoutId);
        }
    }, [recommendedCount, userPrefs]);

    const onPopoverClose = () => {
        setIsPopoverActive(false);
        setHasPopoverBeenClosed(true);
        sessionCache.set(HAS_RECOMMENDATION_POPOVER_BEEN_CLOSED, true);
    };

    return {
        recommendedCount,
        isPopoverActive,
        onPopoverClose
    };
};
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {HAS_RECOMMENDATION_POPOVER_BEEN_CLOSED} from "../../app/constants/storage_keys";
import {IRPStore} from "../../app/rp_reducer";
import {sessionCache} from "../../utils/session_cache";
import {useUserRecommendationState} from "./use_user_recommendation_state";

const POPOVER_ACTIVATION_DELAY = 5000;

export const useUserRecommendationPopover = () => {
    const [hasPopoverBeenClosed, setHasPopoverBeenClosed] = useState<boolean>(sessionCache.get<boolean>(HAS_RECOMMENDATION_POPOVER_BEEN_CLOSED) || false);
    const [isPopoverActive, setIsPopoverActive] = useState(false);
    const {recommendedCount} = useUserRecommendationState();
    const userPrefs = useSelector((state: IRPStore) => state.user.preferences?.data?.filters);
    const userPrefRegions = userPrefs?.region;
    const userPrefFilters =
        userPrefs?.price_0 ||
        userPrefs?.price_1 ||
        userPrefs?.area_0 ||
        userPrefs?.area_1 ||
        userPrefs?.rooms_0 ||
        userPrefs?.rooms_1 ||
        userPrefs?.construction_end_date ||
        userPrefs?.floor_choices;

    useEffect(() => {
        if (recommendedCount > 0 && !hasPopoverBeenClosed && !!userPrefRegions && !!userPrefFilters) {
            const timeoutId = setTimeout(() => {
                setIsPopoverActive(true);
            }, POPOVER_ACTIVATION_DELAY);

            return () => clearTimeout(timeoutId);
        }
    }, [recommendedCount, userPrefs]);

    const onPopoverClose = () => {
        setIsPopoverActive(false);
        setHasPopoverBeenClosed(true);
        sessionCache.set(HAS_RECOMMENDATION_POPOVER_BEEN_CLOSED, true);
    };

    return {
        recommendedCount,
        isPopoverActive,
        onPopoverClose
    };
};
